import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ChangeEmailModalComponent } from './changeEmailModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ChangeEmail: undefined;
  }
}
modalRenderer.register('ChangeEmail', ChangeEmailModalComponent);
